<script lang="ts">
// import axios from 'axios'

export default {
    name: 'SelectEpci',
    emits: ['updateCitiesByInsee'],

    data() {
        return {
            epciList: [],
            selectedEpci: [],
            loadingEpci: true,
            loadingCity: false,
        }
    },
    mounted() {
        this.getEpci()
    },
    methods: {
        getEpci() {
            this.$api.sendRequest({}, 'https://geo.api.gouv.fr/epcis?codeDepartement=17&fields=nom,code&format=json', 'GET').then((res: never[]) => {
                this.epciList = res
                this.loadingEpci = false
            })
        },
        getCommunesFromEpci() {
            this.loadingCity = true
            this.selectedEpci.forEach((epci) => {
                this.$api.sendRequest({}, `https://geo.api.gouv.fr/epcis/${epci}/communes?fields=code&format=json`, 'GET').then((res: any[]) => {
                    const data = res.map(city => city.code)
                    this.$emit('updateCitiesByInsee', data)
                    this.selectedEpci = this.selectedEpci.filter(val => val !== epci)
                    if (!this.selectedEpci.length)
                        this.loadingCity = false
                })
            })
        },
    },
}
</script>

<template>
    <div class="mb-4">
        <v-label class="mt-2 mb-1" for="epci">
            Territoire prédéfini
        </v-label>
        <v-select
            id="epci"
            v-model="selectedEpci"
            :items="epciList"
            multiple
            clearable
            :loading="loadingEpci"
            density="compact"
            variant="solo"
            hide-details
            chips
            item-title="nom"
            item-value="code"
            placeholder="Sélectionner une ou plusieurs valeurs"
        />
        <v-btn class="mt-2" variant="text" :loading="loadingCity" prepend-icon="mdi-plus" color="primary" size="small" :disabled="!selectedEpci.length" @click="getCommunesFromEpci()">
            Ajouter les territoires sélectionnés
        </v-btn>
    </div>
</template>
